<template>
  <div class="horizontal">
    <div
      v-for="item in source.data"
      :key="item[dataKey]"
    >
      <div
        :is="component"
        :source="item"
        :extra-props="extraProps"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    extraProps: {
      type: Object,
      default: () => {}, //额外的参数
    },
    component: {
      type: Object,
      default: () => {}, //cell
    },
    dataKey: {
      type: String,
      default: "",
    },
  },
  created() {
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.horizontal {
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
</style>
